module.exports = __webpack_public_path__ + "static/media/johnson_controls.d5676316.svg";